import nsConfig from '@netsapiens/netsapiens-js/dist/config';
import { select } from 'redux-saga/effects';

import * as actions from '../state';

// eslint-disable-next-line import/prefer-default-export
export function* configureSdk() {
  const sdkConfig = yield select((state) => ({
    apiURL: actions.selectConfig(state, 'apiURL'),
    appName: actions.selectConfig(state, 'appName'),
    portalURL: actions.selectConfig(state, 'portalURL'),
  }));
  const userId = yield select((state) => actions.selectConfig(state, 'userId'));
  if (userId) { sdkConfig.userId = userId; }
  nsConfig.configure(sdkConfig);
}
